if (!customElements.get('fin-logo-preview')) {
  customElements.define('fin-logo-preview', class extends HTMLElement {
    connectedCallback() {
      this.config = JSON.parse(this.querySelector('.fin-preview-data').textContent);
      this.section = this.closest('product-info');
      this.garment = this.querySelector('.fin-preview-garment');
      this.logo = this.querySelector('.fin-preview-logo');
      this.onChange = () => this.update();
      this.section.addEventListener('change', this.onChange);
      this.observer = new MutationObserver(() => this.update());
      this.observer.observe(this.section.querySelector('variant-selects').parentNode, {childList:true,subtree:true});
      this.update();
    }
    disconnectedCallback() {
      this.section?.removeEventListener('change', this.onChange);
      this.observer?.disconnect();
    }
    option(name) {
      const group = this.section.querySelector('[data-fin-option="' + name + '"]');
      return group?.querySelector('input:checked,select')?.value || '';
    }
    update() {
      const color = this.option('Color');
      const logoName = this.option('Logo');
      const print = this.option('Embellishment');
      const image = this.config.colors[color];
      if (image && this.garment && this.garment.getAttribute('src') !== image) {
        this.garment.removeAttribute('srcset');
        this.garment.setAttribute('src', image);
      }
      if (this.config.logos[logoName] && this.logo.getAttribute('src') !== this.config.logos[logoName]) this.logo.src = this.config.logos[logoName];
      this.logo.alt = logoName;
const isHat = ['fincantieri-112', 'fincantieri-ne201', 'fincantieri-nkfd9718'].includes(this.dataset.finHandle);
const logoColor = isHat ? color.split('/')[0].trim() : color;
const light = /white|ivory|cream|natural|yellow|safety|silver|ash|carolina|aquamarine|coral|gusty|light|pink|sand|stone|khaki/i.test(logoColor);      const filter = /laser/i.test(print) ? 'grayscale(1)' : light ? 'none' : 'brightness(0) invert(1)';
      if (this.logo.style.filter !== filter) this.logo.style.filter = filter;
      const caption = [color,logoName,print].filter(Boolean).join(' · ');
      const label = this.querySelector('.fin-preview-caption');
      if (label.textContent !== caption) label.textContent = caption;
    }
  });
}
